import React from 'react';
import { Formik } from 'formik';
import { AliasSearchDto } from '@app/api2/api';
import { SEARCH_TYPES_NAMES } from '../../types';
import { AliasSearchSchema } from './AliasesForm.Schema';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import { FormWithButtons } from './FormWithButtons';

interface Props {
  currentParams: AliasSearchDto;
  setCurrentParams: (p: AliasSearchDto) => void;
}

export default function AliasesForm({ currentParams, setCurrentParams }: Props) {
  const discriminator = SEARCH_TYPES_NAMES.AliasSearchDto;

  const initialValues: AliasSearchDto = {
    discriminator,
    operator: currentParams.operator,
    alias: currentParams.alias || '',
  };

  const handleSubmit = (values: AliasSearchDto) => {
    setCurrentParams({ ...values, discriminator });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={AliasSearchSchema}
      onSubmit={handleSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
    >
      {({ handleSubmit }) => (
        <FormWithButtons handleSubmit={handleSubmit}>
          <SemanticFormikInput
            name="alias"
            label="Alias"
            placeholder="Enter alias"
            required
          />
        </FormWithButtons>
      )}
    </Formik>
  );
}
